import { AtlasClustersResponse, AtlasErrorResponse } from '../types/atlas';

const ATLAS_API_BASE_URL = 'https://spy.playcdu.co/api/notes/atlas';

class AtlasApiService {
  private async request<T>(endpoint: string, options?: RequestInit): Promise<T> {
    const response = await fetch(`${ATLAS_API_BASE_URL}${endpoint}`, {
      ...options,
      // Cloudflare Access handles authentication via cookies
    });

    if (!response.ok) {
      const errorData: AtlasErrorResponse = await response.json().catch(() => ({
        error: `HTTP ${response.status}: ${response.statusText}`,
      }));
      throw new Error(errorData.error || `API Error: ${response.status} ${response.statusText}`);
    }

    return response.json();
  }

  async getClusters(): Promise<AtlasClustersResponse> {
    try {
      return await this.request<AtlasClustersResponse>('/clusters', {
        method: 'GET',
      });
    } catch (error) {
      console.error('Failed to fetch Atlas clusters:', error);
      throw error;
    }
  }
}

export const atlasApiService = new AtlasApiService();

